import jQuery from 'jquery';
import 'jquery.easing';
import Header from './modules/Header';
import Router from './modules/Router';
import SpMenu from './modules/SpMenu';
import Transition from './modules/Transition';
import InviewObj from './modules/InviewObj';

const $ = jQuery;
window.jQuery = $;
window.$ = $;
window.onLoadComplete = false;

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
window.addEventListener('resize', setFillHeight);
setFillHeight();

class MainApp {
  constructor() {
    this.$window = $(window);
    this.transition = new Transition();
    this.header = new Header();
    this.spMenu = new SpMenu();
    this.router = new Router(this);
    this.fxImgSet = [];

    $('.check-acceptance').each((i, e) => {
      if ($(e).text() == '1') {
        $(e).text('チェックあり');
      } else {
        $(e).text('チェックなし');
      }
    });

    $(document).on('touchstart', 'a, button', (e) => {
      $(e.currentTarget).attr('data-touch', 'true');
    });

    $(document).on('mouseleave', 'a, button', (e) => {
      $(e.currentTarget).removeAttr('data-touch');
    });

    $(document).on('click', 'a', (e) => {
      if ($(e.currentTarget).attr('href').slice(0, 1) == '#') {
        if ($($(e.currentTarget).attr('href')).length) {
          this.scrollPage($($(e.currentTarget).attr('href')).offset()['top']);
        } else {
          console.log('hrefに指定されているIDの要素は存在しません');
        }
        e.preventDefault();
      }
    });

    $(document).on('click', '.js-show-allposts', (e) => {
      $(e.currentTarget).parent().css('display', 'none');
      if ($('.show-limit').length) {
        $('.show-limit').addClass('show-all');
      }
    });

    $(document).on('mouseover', 'a.Card', (e) => {
      // console.log('hover card');
      $(e.currentTarget)
        .find('.Img')
        .stop(false)
        .css('opacity', 0.55)
        .delay(40)
        .animate({ opacity: 1 }, 600, 'easeOutSine');
    });

    this.scrollableElement = null;
    let firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
    if ('scrollingElement' in document) {
      this.scrollableElement = document.scrollingElement;
    } else if (
      /*@cc_on!@*/ false ||
      (!!window.MSInputMethodContext && !!document.documentMode)
    ) {
      this.scrollableElement = document.documentElement;
    } else if (firefox && parseInt(firefox[1]) <= 47) {
      this.scrollableElement = document.documentElement;
    } else {
      this.scrollableElement = document.body;
    }

    this.$window
      .on('resize', () => {
        this.onWindowResize();
      })
      .on('scroll', () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }

  /*
  isTouchDevice() {
    return ('ontouchstart' in window || navigator.msPointerEnabled) ? true : false;
  }
  */
  destroyPageApp() {
    if (this.fxImgSet.length) {
      for (let i = 0; i < this.fxImgSet.length; i++) {
        this.fxImgSet[i] = null;
      }
      this.fxImgSet = [];
    }
  }
  setPageApp() {
    this.fxImgSet = [];
    this.findElement = $('div[data-barba="container"]');
    this.findElement.find('.InviewObj').each((i, e) => {
      this.fxImgSet.push(new InviewObj($(e)));
    });

    setTimeout(() => {
      this.onWindowResize();
    }, 500);
  }

  scrollPage(val, isCancelTransition = false) {
    if (isCancelTransition) {
      $(this.scrollableElement)
        .stop(false)
        .scrollTop(val - $('.Header').height());
    } else {
      $(this.scrollableElement)
        .stop(false)
        .animate(
          { scrollTop: val - $('.Header').height() },
          1200,
          'easeInOutExpo',
        );
    }
  }

  onWindowResize() {
    this.windowWidth = this.$window.width();
    this.windowHeight = this.$window.height();

    if (this.pageApp != undefined) {
      this.pageApp.onWindowResize();
    }

    this.onWindowScroll();
  }

  onWindowScroll() {
    this.scrollTop = this.$window.scrollTop();
    if (this.pageApp != undefined) {
      this.pageApp.onWindowScroll(this.scrollTop);
    }

    if (parseInt(Math.random() * 10) < 5) {
      this.transition.slidein();
    }

    if (this.fxImgSet) {
      for (let i = 0; i < this.fxImgSet.length; i++) {
        this.fxImgSet[i].update(this.scrollTop, this.windowHeight);
      }
    }
  }
}

$('document').ready(() => {
  new MainApp();
});

$(window).on('load', () => {
  window.onLoadComplete = true;
});
